<template>
  <b-row>
    <b-col md="8">
      <b-card :title="`ویرایش ویدئو &quot; ${video.name} &quot;`">
        <Rinput label="نام ویدئو" v-model="video.name" :required="true" />
        <Rtextarea label="توضیحات ویدئو" v-model="video.detial" />
        <vue-tags-input
          class="w-100 mb-3 tags"
          v-model="video.tag"
          :tags="video.tags"
          :allow-edit-tags="true"
          placeholder="کلیدواژه ها"
          @tags-changed="(newTags) => (video.tags = newTags)"
        />
        <Rupload
          label="فایل ویدئو"
          accept="video/*"
          :required="true"
          v-model="video.videofile"
          url="admin/video/file"
        />
      </b-card>
    </b-col>
    <b-col md="4">
      <b-button variant="success" class="w-100 mb-2" @click="send"
        >ذخیره ویدئو</b-button
      >
      <b-card>
        <Rupload
          label="کاور ویدئو"
          accept="image/*"
          v-model="video.videocover"
          :required="true"
          url="admin/video/coverfile"
        />
        <b-form-group label="موضوع" label-class="required">
          <b-select v-model="video.cat" required>
            <option
              v-for="(catitem, index) in cats"
              v-bind:key="index"
              :value="catitem.id"
            >
              <b v-if="catitem.parentid != 0">{{ catitem.parent }} =></b>
              {{ catitem.label }} [ {{ catitem.lang }} ]
            </option>
          </b-select>
        </b-form-group>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import ApiService from "@/core/services/api.service";
export default {
  name: "import",
  data() {
    return {
      cats: [],
      tag: "",
      tags: [],
      video: {
        name: "",
        detial: "",
        tag: "",
        tags: [],
        cat: "",
        videofile: null,
        videocover: null,
      },
    };
  },

  created() {
    this.gettaxnomy();
    this.getvideo();
  },
  computed: {
    routeTab() {
      // 1. Only update tab title
      return `ویرایش ${this.video.name}`;
    },
  },
  methods: {
    getvideo: function () {
      let id = this.$route.params.id;
      ApiService.query("admin/video/" + id, {})
        .then(({ data }) => {
          this.video = data.data;
        })
        .catch(({ response }) => {});
    },
    gettaxnomy: function () {
      ApiService.query("admin/taxnomy", {
        params: {
          type: "video",
        },
      })
        .then(({ data }) => {
          this.cats = data;
        })
        .catch(({ response }) => {});
    },
    send() {
      let id = this.$route.params.id;
      if (this.video.videofile != null && this.video.videocover != null) {
        ApiService.put("admin/video/" + id + "#", {
          id: id,
          video: this.video,
        })
          .then(({ data }) => {
            this.$vs.notification({
              progress: "auto",
              color: "success",
              position: "bottom-left",
              text: "ویدئو با موفقیت ویرایش گردید",
            });
            this.$router.push({ path: "/video/manager" });
          })
          .catch(({ response }) => {
            this.$vs.notification({
              progress: "auto",
              color: "danger",
              position: "bottom-left",
              text: "ذخیره ویدئو با خطا مواجه گردید",
            });
          });
      } else {
        this.$vs.notification({
          progress: "auto",
          color: "danger",
          position: "bottom-left",
          text: "مقادیر اجباری نمیتواند خالی باشد.",
        });
      }
    },
  },
};
</script>
<style lang="scss">
.tags {
  max-width: 100% !important;
  input {
    max-width: 100% !important;
    width: 100%;
  }
}
</style>
